export const countries = [
  {
    "name": "Afghanistan",
    "iso2": "AF",
    "iso3": "AFG",
    "phone": "+93",
    "flag": "🇦🇫"
  },
  {
    "name": "Albania",
    "iso2": "AL",
    "iso3": "ALB",
    "phone": "+355",
    "flag": "🇦🇱"
  },
  {
    "name": "Algeria",
    "iso2": "DZ",
    "iso3": "DZA",
    "phone": "+213",
    "flag": "🇩🇿"
  },
  {
    "name": "American Samoa",
    "iso2": "AS",
    "iso3": "ASM",
    "phone": "+1684",
    "flag": "🇦🇸"
  },
  {
    "name": "Andorra",
    "iso2": "AD",
    "iso3": "AND",
    "phone": "+376",
    "flag": "🇦🇩"
  },
  {
    "name": "Angola",
    "iso2": "AO",
    "iso3": "AGO",
    "phone": "+244",
    "flag": "🇦🇴"
  },
  {
    "name": "Anguilla",
    "iso2": "AI",
    "iso3": "AIA",
    "phone": "+1264",
    "flag": "🇦🇮"
  },
  {
    "name": "Antarctica",
    "iso2": "AQ",
    "iso3": "ATA",
    "phone": "",
    "flag": "🇦🇶"
  },
  {
    "name": "Antigua and Barbuda",
    "iso2": "AG",
    "iso3": "ATG",
    "phone": "+1268",
    "flag": "🇦🇬"
  },
  {
    "name": "Argentina",
    "iso2": "AR",
    "iso3": "ARG",
    "phone": "+54",
    "flag": "🇦🇷"
  },
  {
    "name": "Armenia",
    "iso2": "AM",
    "iso3": "ARM",
    "phone": "+374",
    "flag": "🇦🇲"
  },
  {
    "name": "Aruba",
    "iso2": "AW",
    "iso3": "ABW",
    "phone": "+297",
    "flag": "🇦🇼"
  },
  {
    "name": "Australia",
    "iso2": "AU",
    "iso3": "AUS",
    "phone": "+61",
    "flag": "🇦🇺"
  },
  {
    "name": "Austria",
    "iso2": "AT",
    "iso3": "AUT",
    "phone": "+43",
    "flag": "🇦🇹"
  },
  {
    "name": "Azerbaijan",
    "iso2": "AZ",
    "iso3": "AZE",
    "phone": "+994",
    "flag": "🇦🇿"
  },
  {
    "name": "Bahamas",
    "iso2": "BS",
    "iso3": "BHS",
    "phone": "+1242",
    "flag": "🇧🇸"
  },
  {
    "name": "Bahrain",
    "iso2": "BH",
    "iso3": "BHR",
    "phone": "+973",
    "flag": "🇧🇭"
  },
  {
    "name": "Bangladesh",
    "iso2": "BD",
    "iso3": "BGD",
    "phone": "+880",
    "flag": "🇧🇩"
  },
  {
    "name": "Barbados",
    "iso2": "BB",
    "iso3": "BRB",
    "phone": "+1246",
    "flag": "🇧🇧"
  },
  {
    "name": "Belarus",
    "iso2": "BY",
    "iso3": "BLR",
    "phone": "+375",
    "flag": "🇧🇾"
  },
  {
    "name": "Belgium",
    "iso2": "BE",
    "iso3": "BEL",
    "phone": "+32",
    "flag": "🇧🇪"
  },
  {
    "name": "Belize",
    "iso2": "BZ",
    "iso3": "BLZ",
    "phone": "+501",
    "flag": "🇧🇿"
  },
  {
    "name": "Benin",
    "iso2": "BJ",
    "iso3": "BEN",
    "phone": "+229",
    "flag": "🇧🇯"
  },
  {
    "name": "Bermuda",
    "iso2": "BM",
    "iso3": "BMU",
    "phone": "+1441",
    "flag": "🇧🇲"
  },
  {
    "name": "Bhutan",
    "iso2": "BT",
    "iso3": "BTN",
    "phone": "+975",
    "flag": "🇧🇹"
  },
  {
    "name": "Bolivia",
    "iso2": "BO",
    "iso3": "BOL",
    "phone": "+591",
    "flag": "🇧🇴"
  },
  {
    "name": "Bosnia and Herzegovina",
    "iso2": "BA",
    "iso3": "BIH",
    "phone": "+387",
    "flag": "🇧🇦"
  },
  {
    "name": "Botswana",
    "iso2": "BW",
    "iso3": "BWA",
    "phone": "+267",
    "flag": "🇧🇼"
  },
  {
    "name": "Bouvet Island",
    "iso2": "BV",
    "iso3": "BVT",
    "phone": "+47",
    "flag": "🇧🇻"
  },
  {
    "name": "Brazil",
    "iso2": "BR",
    "iso3": "BRA",
    "phone": "+55",
    "flag": "🇧🇷"
  },
  {
    "name": "British Indian Ocean Territory",
    "iso2": "IO",
    "iso3": "IOT",
    "phone": "+246",
    "flag": "🇮🇴"
  },
  {
    "name": "British Virgin Islands",
    "iso2": "VG",
    "iso3": "VGB",
    "phone": "+1284",
    "flag": "🇻🇬"
  },
  {
    "name": "Brunei",
    "iso2": "BN",
    "iso3": "BRN",
    "phone": "+673",
    "flag": "🇧🇳"
  },
  {
    "name": "Bulgaria",
    "iso2": "BG",
    "iso3": "BGR",
    "phone": "+359",
    "flag": "🇧🇬"
  },
  {
    "name": "Burkina Faso",
    "iso2": "BF",
    "iso3": "BFA",
    "phone": "+226",
    "flag": "🇧🇫"
  },
  {
    "name": "Burundi",
    "iso2": "BI",
    "iso3": "BDI",
    "phone": "+257",
    "flag": "🇧🇮"
  },
  {
    "name": "Cambodia",
    "iso2": "KH",
    "iso3": "KHM",
    "phone": "+855",
    "flag": "🇰🇭"
  },
  {
    "name": "Cameroon",
    "iso2": "CM",
    "iso3": "CMR",
    "phone": "+237",
    "flag": "🇨🇲"
  },
  {
    "name": "Canada",
    "iso2": "CA",
    "iso3": "CAN",
    "phone": "+1",
    "flag": "🇨🇦"
  },
  {
    "name": "Cape Verde",
    "iso2": "CV",
    "iso3": "CPV",
    "phone": "+238",
    "flag": "🇨🇻"
  },
  {
    "name": "Caribbean Netherlands",
    "iso2": "BQ",
    "iso3": "BES",
    "phone": "+599",
    "flag": "🇧🇶"
  },
  {
    "name": "Cayman Islands",
    "iso2": "KY",
    "iso3": "CYM",
    "phone": "+1345",
    "flag": "🇰🇾"
  },
  {
    "name": "Central African Republic",
    "iso2": "CF",
    "iso3": "CAF",
    "phone": "+236",
    "flag": "🇨🇫"
  },
  {
    "name": "Chad",
    "iso2": "TD",
    "iso3": "TCD",
    "phone": "+235",
    "flag": "🇹🇩"
  },
  {
    "name": "Chile",
    "iso2": "CL",
    "iso3": "CHL",
    "phone": "+56",
    "flag": "🇨🇱"
  },
  {
    "name": "China",
    "iso2": "CN",
    "iso3": "CHN",
    "phone": "+86",
    "flag": "🇨🇳"
  },
  {
    "name": "Christmas Island",
    "iso2": "CX",
    "iso3": "CXR",
    "phone": "+61",
    "flag": "🇨🇽"
  },
  {
    "name": "Cocos (Keeling) Islands",
    "iso2": "CC",
    "iso3": "CCK",
    "phone": "+61",
    "flag": "🇨🇨"
  },
  {
    "name": "Colombia",
    "iso2": "CO",
    "iso3": "COL",
    "phone": "+57",
    "flag": "🇨🇴"
  },
  {
    "name": "Comoros",
    "iso2": "KM",
    "iso3": "COM",
    "phone": "+269",
    "flag": "🇰🇲"
  },
  {
    "name": "Cook Islands",
    "iso2": "CK",
    "iso3": "COK",
    "phone": "+682",
    "flag": "🇨🇰"
  },
  {
    "name": "Costa Rica",
    "iso2": "CR",
    "iso3": "CRI",
    "phone": "+506",
    "flag": "🇨🇷"
  },
  {
    "name": "Croatia",
    "iso2": "HR",
    "iso3": "HRV",
    "phone": "+385",
    "flag": "🇭🇷"
  },
  {
    "name": "Cuba",
    "iso2": "CU",
    "iso3": "CUB",
    "phone": "+53",
    "flag": "🇨🇺"
  },
  {
    "name": "Curaçao",
    "iso2": "CW",
    "iso3": "CUW",
    "phone": "+599",
    "flag": "🇨🇼"
  },
  {
    "name": "Cyprus",
    "iso2": "CY",
    "iso3": "CYP",
    "phone": "+357",
    "flag": "🇨🇾"
  },
  {
    "name": "Czechia",
    "iso2": "CZ",
    "iso3": "CZE",
    "phone": "+420",
    "flag": "🇨🇿"
  },
  {
    "name": "DR Congo",
    "iso2": "CD",
    "iso3": "COD",
    "phone": "+243",
    "flag": "🇨🇩"
  },
  {
    "name": "Denmark",
    "iso2": "DK",
    "iso3": "DNK",
    "phone": "+45",
    "flag": "🇩🇰"
  },
  {
    "name": "Djibouti",
    "iso2": "DJ",
    "iso3": "DJI",
    "phone": "+253",
    "flag": "🇩🇯"
  },
  {
    "name": "Dominica",
    "iso2": "DM",
    "iso3": "DMA",
    "phone": "+1767",
    "flag": "🇩🇲"
  },
  {
    "name": "Dominican Republic",
    "iso2": "DO",
    "iso3": "DOM",
    "phone": "+1809",
    "flag": "🇩🇴"
  },
  {
    "name": "Ecuador",
    "iso2": "EC",
    "iso3": "ECU",
    "phone": "+593",
    "flag": "🇪🇨"
  },
  {
    "name": "Egypt",
    "iso2": "EG",
    "iso3": "EGY",
    "phone": "+20",
    "flag": "🇪🇬"
  },
  {
    "name": "El Salvador",
    "iso2": "SV",
    "iso3": "SLV",
    "phone": "+503",
    "flag": "🇸🇻"
  },
  {
    "name": "Equatorial Guinea",
    "iso2": "GQ",
    "iso3": "GNQ",
    "phone": "+240",
    "flag": "🇬🇶"
  },
  {
    "name": "Eritrea",
    "iso2": "ER",
    "iso3": "ERI",
    "phone": "+291",
    "flag": "🇪🇷"
  },
  {
    "name": "Estonia",
    "iso2": "EE",
    "iso3": "EST",
    "phone": "+372",
    "flag": "🇪🇪"
  },
  {
    "name": "Eswatini",
    "iso2": "SZ",
    "iso3": "SWZ",
    "phone": "+268",
    "flag": "🇸🇿"
  },
  {
    "name": "Ethiopia",
    "iso2": "ET",
    "iso3": "ETH",
    "phone": "+251",
    "flag": "🇪🇹"
  },
  {
    "name": "Falkland Islands",
    "iso2": "FK",
    "iso3": "FLK",
    "phone": "+500",
    "flag": "🇫🇰"
  },
  {
    "name": "Faroe Islands",
    "iso2": "FO",
    "iso3": "FRO",
    "phone": "+298",
    "flag": "🇫🇴"
  },
  {
    "name": "Fiji",
    "iso2": "FJ",
    "iso3": "FJI",
    "phone": "+679",
    "flag": "🇫🇯"
  },
  {
    "name": "Finland",
    "iso2": "FI",
    "iso3": "FIN",
    "phone": "+358",
    "flag": "🇫🇮"
  },
  {
    "name": "France",
    "iso2": "FR",
    "iso3": "FRA",
    "phone": "+33",
    "flag": "🇫🇷"
  },
  {
    "name": "French Guiana",
    "iso2": "GF",
    "iso3": "GUF",
    "phone": "+594",
    "flag": "🇬🇫"
  },
  {
    "name": "French Polynesia",
    "iso2": "PF",
    "iso3": "PYF",
    "phone": "+689",
    "flag": "🇵🇫"
  },
  {
    "name": "French Southern and Antarctic Lands",
    "iso2": "TF",
    "iso3": "ATF",
    "phone": "+262",
    "flag": "🇹🇫"
  },
  {
    "name": "Gabon",
    "iso2": "GA",
    "iso3": "GAB",
    "phone": "+241",
    "flag": "🇬🇦"
  },
  {
    "name": "Gambia",
    "iso2": "GM",
    "iso3": "GMB",
    "phone": "+220",
    "flag": "🇬🇲"
  },
  {
    "name": "Georgia",
    "iso2": "GE",
    "iso3": "GEO",
    "phone": "+995",
    "flag": "🇬🇪"
  },
  {
    "name": "Germany",
    "iso2": "DE",
    "iso3": "DEU",
    "phone": "+49",
    "flag": "🇩🇪"
  },
  {
    "name": "Ghana",
    "iso2": "GH",
    "iso3": "GHA",
    "phone": "+233",
    "flag": "🇬🇭"
  },
  {
    "name": "Gibraltar",
    "iso2": "GI",
    "iso3": "GIB",
    "phone": "+350",
    "flag": "🇬🇮"
  },
  {
    "name": "Greece",
    "iso2": "GR",
    "iso3": "GRC",
    "phone": "+30",
    "flag": "🇬🇷"
  },
  {
    "name": "Greenland",
    "iso2": "GL",
    "iso3": "GRL",
    "phone": "+299",
    "flag": "🇬🇱"
  },
  {
    "name": "Grenada",
    "iso2": "GD",
    "iso3": "GRD",
    "phone": "+1473",
    "flag": "🇬🇩"
  },
  {
    "name": "Guadeloupe",
    "iso2": "GP",
    "iso3": "GLP",
    "phone": "+590",
    "flag": "🇬🇵"
  },
  {
    "name": "Guam",
    "iso2": "GU",
    "iso3": "GUM",
    "phone": "+1671",
    "flag": "🇬🇺"
  },
  {
    "name": "Guatemala",
    "iso2": "GT",
    "iso3": "GTM",
    "phone": "+502",
    "flag": "🇬🇹"
  },
  {
    "name": "Guernsey",
    "iso2": "GG",
    "iso3": "GGY",
    "phone": "+44",
    "flag": "🇬🇬"
  },
  {
    "name": "Guinea",
    "iso2": "GN",
    "iso3": "GIN",
    "phone": "+224",
    "flag": "🇬🇳"
  },
  {
    "name": "Guinea-Bissau",
    "iso2": "GW",
    "iso3": "GNB",
    "phone": "+245",
    "flag": "🇬🇼"
  },
  {
    "name": "Guyana",
    "iso2": "GY",
    "iso3": "GUY",
    "phone": "+592",
    "flag": "🇬🇾"
  },
  {
    "name": "Haiti",
    "iso2": "HT",
    "iso3": "HTI",
    "phone": "+509",
    "flag": "🇭🇹"
  },
  {
    "name": "Heard Island and McDonald Islands",
    "iso2": "HM",
    "iso3": "HMD",
    "phone": "",
    "flag": "🇭🇲"
  },
  {
    "name": "Honduras",
    "iso2": "HN",
    "iso3": "HND",
    "phone": "+504",
    "flag": "🇭🇳"
  },
  {
    "name": "Hong Kong",
    "iso2": "HK",
    "iso3": "HKG",
    "phone": "+852",
    "flag": "🇭🇰"
  },
  {
    "name": "Hungary",
    "iso2": "HU",
    "iso3": "HUN",
    "phone": "+36",
    "flag": "🇭🇺"
  },
  {
    "name": "Iceland",
    "iso2": "IS",
    "iso3": "ISL",
    "phone": "+354",
    "flag": "🇮🇸"
  },
  {
    "name": "India",
    "iso2": "IN",
    "iso3": "IND",
    "phone": "+91",
    "flag": "🇮🇳"
  },
  {
    "name": "Indonesia",
    "iso2": "ID",
    "iso3": "IDN",
    "phone": "+62",
    "flag": "🇮🇩"
  },
  {
    "name": "Iran",
    "iso2": "IR",
    "iso3": "IRN",
    "phone": "+98",
    "flag": "🇮🇷"
  },
  {
    "name": "Iraq",
    "iso2": "IQ",
    "iso3": "IRQ",
    "phone": "+964",
    "flag": "🇮🇶"
  },
  {
    "name": "Ireland",
    "iso2": "IE",
    "iso3": "IRL",
    "phone": "+353",
    "flag": "🇮🇪"
  },
  {
    "name": "Isle of Man",
    "iso2": "IM",
    "iso3": "IMN",
    "phone": "+44",
    "flag": "🇮🇲"
  },
  {
    "name": "Israel",
    "iso2": "IL",
    "iso3": "ISR",
    "phone": "+972",
    "flag": "🇮🇱"
  },
  {
    "name": "Italy",
    "iso2": "IT",
    "iso3": "ITA",
    "phone": "+39",
    "flag": "🇮🇹"
  },
  {
    "name": "Ivory Coast",
    "iso2": "CI",
    "iso3": "CIV",
    "phone": "+225",
    "flag": "🇨🇮"
  },
  {
    "name": "Jamaica",
    "iso2": "JM",
    "iso3": "JAM",
    "phone": "+1876",
    "flag": "🇯🇲"
  },
  {
    "name": "Japan",
    "iso2": "JP",
    "iso3": "JPN",
    "phone": "+81",
    "flag": "🇯🇵"
  },
  {
    "name": "Jersey",
    "iso2": "JE",
    "iso3": "JEY",
    "phone": "+44",
    "flag": "🇯🇪"
  },
  {
    "name": "Jordan",
    "iso2": "JO",
    "iso3": "JOR",
    "phone": "+962",
    "flag": "🇯🇴"
  },
  {
    "name": "Kazakhstan",
    "iso2": "KZ",
    "iso3": "KAZ",
    "phone": "+76",
    "flag": "🇰🇿"
  },
  {
    "name": "Kenya",
    "iso2": "KE",
    "iso3": "KEN",
    "phone": "+254",
    "flag": "🇰🇪"
  },
  {
    "name": "Kiribati",
    "iso2": "KI",
    "iso3": "KIR",
    "phone": "+686",
    "flag": "🇰🇮"
  },
  {
    "name": "Kosovo",
    "iso2": "XK",
    "iso3": "UNK",
    "phone": "+383",
    "flag": "🇽🇰"
  },
  {
    "name": "Kuwait",
    "iso2": "KW",
    "iso3": "KWT",
    "phone": "+965",
    "flag": "🇰🇼"
  },
  {
    "name": "Kyrgyzstan",
    "iso2": "KG",
    "iso3": "KGZ",
    "phone": "+996",
    "flag": "🇰🇬"
  },
  {
    "name": "Laos",
    "iso2": "LA",
    "iso3": "LAO",
    "phone": "+856",
    "flag": "🇱🇦"
  },
  {
    "name": "Latvia",
    "iso2": "LV",
    "iso3": "LVA",
    "phone": "+371",
    "flag": "🇱🇻"
  },
  {
    "name": "Lebanon",
    "iso2": "LB",
    "iso3": "LBN",
    "phone": "+961",
    "flag": "🇱🇧"
  },
  {
    "name": "Lesotho",
    "iso2": "LS",
    "iso3": "LSO",
    "phone": "+266",
    "flag": "🇱🇸"
  },
  {
    "name": "Liberia",
    "iso2": "LR",
    "iso3": "LBR",
    "phone": "+231",
    "flag": "🇱🇷"
  },
  {
    "name": "Libya",
    "iso2": "LY",
    "iso3": "LBY",
    "phone": "+218",
    "flag": "🇱🇾"
  },
  {
    "name": "Liechtenstein",
    "iso2": "LI",
    "iso3": "LIE",
    "phone": "+423",
    "flag": "🇱🇮"
  },
  {
    "name": "Lithuania",
    "iso2": "LT",
    "iso3": "LTU",
    "phone": "+370",
    "flag": "🇱🇹"
  },
  {
    "name": "Luxembourg",
    "iso2": "LU",
    "iso3": "LUX",
    "phone": "+352",
    "flag": "🇱🇺"
  },
  {
    "name": "Macau",
    "iso2": "MO",
    "iso3": "MAC",
    "phone": "+853",
    "flag": "🇲🇴"
  },
  {
    "name": "Madagascar",
    "iso2": "MG",
    "iso3": "MDG",
    "phone": "+261",
    "flag": "🇲🇬"
  },
  {
    "name": "Malawi",
    "iso2": "MW",
    "iso3": "MWI",
    "phone": "+265",
    "flag": "🇲🇼"
  },
  {
    "name": "Malaysia",
    "iso2": "MY",
    "iso3": "MYS",
    "phone": "+60",
    "flag": "🇲🇾"
  },
  {
    "name": "Maldives",
    "iso2": "MV",
    "iso3": "MDV",
    "phone": "+960",
    "flag": "🇲🇻"
  },
  {
    "name": "Mali",
    "iso2": "ML",
    "iso3": "MLI",
    "phone": "+223",
    "flag": "🇲🇱"
  },
  {
    "name": "Malta",
    "iso2": "MT",
    "iso3": "MLT",
    "phone": "+356",
    "flag": "🇲🇹"
  },
  {
    "name": "Marshall Islands",
    "iso2": "MH",
    "iso3": "MHL",
    "phone": "+692",
    "flag": "🇲🇭"
  },
  {
    "name": "Martinique",
    "iso2": "MQ",
    "iso3": "MTQ",
    "phone": "+596",
    "flag": "🇲🇶"
  },
  {
    "name": "Mauritania",
    "iso2": "MR",
    "iso3": "MRT",
    "phone": "+222",
    "flag": "🇲🇷"
  },
  {
    "name": "Mauritius",
    "iso2": "MU",
    "iso3": "MUS",
    "phone": "+230",
    "flag": "🇲🇺"
  },
  {
    "name": "Mayotte",
    "iso2": "YT",
    "iso3": "MYT",
    "phone": "+262",
    "flag": "🇾🇹"
  },
  {
    "name": "Mexico",
    "iso2": "MX",
    "iso3": "MEX",
    "phone": "+52",
    "flag": "🇲🇽"
  },
  {
    "name": "Micronesia",
    "iso2": "FM",
    "iso3": "FSM",
    "phone": "+691",
    "flag": "🇫🇲"
  },
  {
    "name": "Moldova",
    "iso2": "MD",
    "iso3": "MDA",
    "phone": "+373",
    "flag": "🇲🇩"
  },
  {
    "name": "Monaco",
    "iso2": "MC",
    "iso3": "MCO",
    "phone": "+377",
    "flag": "🇲🇨"
  },
  {
    "name": "Mongolia",
    "iso2": "MN",
    "iso3": "MNG",
    "phone": "+976",
    "flag": "🇲🇳"
  },
  {
    "name": "Montenegro",
    "iso2": "ME",
    "iso3": "MNE",
    "phone": "+382",
    "flag": "🇲🇪"
  },
  {
    "name": "Montserrat",
    "iso2": "MS",
    "iso3": "MSR",
    "phone": "+1664",
    "flag": "🇲🇸"
  },
  {
    "name": "Morocco",
    "iso2": "MA",
    "iso3": "MAR",
    "phone": "+212",
    "flag": "🇲🇦"
  },
  {
    "name": "Mozambique",
    "iso2": "MZ",
    "iso3": "MOZ",
    "phone": "+258",
    "flag": "🇲🇿"
  },
  {
    "name": "Myanmar",
    "iso2": "MM",
    "iso3": "MMR",
    "phone": "+95",
    "flag": "🇲🇲"
  },
  {
    "name": "Namibia",
    "iso2": "NA",
    "iso3": "NAM",
    "phone": "+264",
    "flag": "🇳🇦"
  },
  {
    "name": "Nauru",
    "iso2": "NR",
    "iso3": "NRU",
    "phone": "+674",
    "flag": "🇳🇷"
  },
  {
    "name": "Nepal",
    "iso2": "NP",
    "iso3": "NPL",
    "phone": "+977",
    "flag": "🇳🇵"
  },
  {
    "name": "Netherlands",
    "iso2": "NL",
    "iso3": "NLD",
    "phone": "+31",
    "flag": "🇳🇱"
  },
  {
    "name": "New Caledonia",
    "iso2": "NC",
    "iso3": "NCL",
    "phone": "+687",
    "flag": "🇳🇨"
  },
  {
    "name": "New Zealand",
    "iso2": "NZ",
    "iso3": "NZL",
    "phone": "+64",
    "flag": "🇳🇿"
  },
  {
    "name": "Nicaragua",
    "iso2": "NI",
    "iso3": "NIC",
    "phone": "+505",
    "flag": "🇳🇮"
  },
  {
    "name": "Niger",
    "iso2": "NE",
    "iso3": "NER",
    "phone": "+227",
    "flag": "🇳🇪"
  },
  {
    "name": "Nigeria",
    "iso2": "NG",
    "iso3": "NGA",
    "phone": "+234",
    "flag": "🇳🇬"
  },
  {
    "name": "Niue",
    "iso2": "NU",
    "iso3": "NIU",
    "phone": "+683",
    "flag": "🇳🇺"
  },
  {
    "name": "Norfolk Island",
    "iso2": "NF",
    "iso3": "NFK",
    "phone": "+672",
    "flag": "🇳🇫"
  },
  {
    "name": "North Korea",
    "iso2": "KP",
    "iso3": "PRK",
    "phone": "+850",
    "flag": "🇰🇵"
  },
  {
    "name": "North Macedonia",
    "iso2": "MK",
    "iso3": "MKD",
    "phone": "+389",
    "flag": "🇲🇰"
  },
  {
    "name": "Northern Mariana Islands",
    "iso2": "MP",
    "iso3": "MNP",
    "phone": "+1670",
    "flag": "🇲🇵"
  },
  {
    "name": "Norway",
    "iso2": "NO",
    "iso3": "NOR",
    "phone": "+47",
    "flag": "🇳🇴"
  },
  {
    "name": "Oman",
    "iso2": "OM",
    "iso3": "OMN",
    "phone": "+968",
    "flag": "🇴🇲"
  },
  {
    "name": "Pakistan",
    "iso2": "PK",
    "iso3": "PAK",
    "phone": "+92",
    "flag": "🇵🇰"
  },
  {
    "name": "Palau",
    "iso2": "PW",
    "iso3": "PLW",
    "phone": "+680",
    "flag": "🇵🇼"
  },
  {
    "name": "Palestine",
    "iso2": "PS",
    "iso3": "PSE",
    "phone": "+970",
    "flag": "🇵🇸"
  },
  {
    "name": "Panama",
    "iso2": "PA",
    "iso3": "PAN",
    "phone": "+507",
    "flag": "🇵🇦"
  },
  {
    "name": "Papua New Guinea",
    "iso2": "PG",
    "iso3": "PNG",
    "phone": "+675",
    "flag": "🇵🇬"
  },
  {
    "name": "Paraguay",
    "iso2": "PY",
    "iso3": "PRY",
    "phone": "+595",
    "flag": "🇵🇾"
  },
  {
    "name": "Peru",
    "iso2": "PE",
    "iso3": "PER",
    "phone": "+51",
    "flag": "🇵🇪"
  },
  {
    "name": "Philippines",
    "iso2": "PH",
    "iso3": "PHL",
    "phone": "+63",
    "flag": "🇵🇭"
  },
  {
    "name": "Pitcairn Islands",
    "iso2": "PN",
    "iso3": "PCN",
    "phone": "+64",
    "flag": "🇵🇳"
  },
  {
    "name": "Poland",
    "iso2": "PL",
    "iso3": "POL",
    "phone": "+48",
    "flag": "🇵🇱"
  },
  {
    "name": "Portugal",
    "iso2": "PT",
    "iso3": "PRT",
    "phone": "+351",
    "flag": "🇵🇹"
  },
  {
    "name": "Puerto Rico",
    "iso2": "PR",
    "iso3": "PRI",
    "phone": "+1787",
    "flag": "🇵🇷"
  },
  {
    "name": "Qatar",
    "iso2": "QA",
    "iso3": "QAT",
    "phone": "+974",
    "flag": "🇶🇦"
  },
  {
    "name": "Republic of the Congo",
    "iso2": "CG",
    "iso3": "COG",
    "phone": "+242",
    "flag": "🇨🇬"
  },
  {
    "name": "Romania",
    "iso2": "RO",
    "iso3": "ROU",
    "phone": "+40",
    "flag": "🇷🇴"
  },
  {
    "name": "Russia",
    "iso2": "RU",
    "iso3": "RUS",
    "phone": "+73",
    "flag": "🇷🇺"
  },
  {
    "name": "Rwanda",
    "iso2": "RW",
    "iso3": "RWA",
    "phone": "+250",
    "flag": "🇷🇼"
  },
  {
    "name": "Réunion",
    "iso2": "RE",
    "iso3": "REU",
    "phone": "+262",
    "flag": "🇷🇪"
  },
  {
    "name": "Saint Barthélemy",
    "iso2": "BL",
    "iso3": "BLM",
    "phone": "+590",
    "flag": "🇧🇱"
  },
  {
    "name": "Saint Helena, Ascension and Tristan da Cunha",
    "iso2": "SH",
    "iso3": "SHN",
    "phone": "+290",
    "flag": "🇸🇭"
  },
  {
    "name": "Saint Kitts and Nevis",
    "iso2": "KN",
    "iso3": "KNA",
    "phone": "+1869",
    "flag": "🇰🇳"
  },
  {
    "name": "Saint Lucia",
    "iso2": "LC",
    "iso3": "LCA",
    "phone": "+1758",
    "flag": "🇱🇨"
  },
  {
    "name": "Saint Martin",
    "iso2": "MF",
    "iso3": "MAF",
    "phone": "+590",
    "flag": "🇲🇫"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "iso2": "PM",
    "iso3": "SPM",
    "phone": "+508",
    "flag": "🇵🇲"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "iso2": "VC",
    "iso3": "VCT",
    "phone": "+1784",
    "flag": "🇻🇨"
  },
  {
    "name": "Samoa",
    "iso2": "WS",
    "iso3": "WSM",
    "phone": "+685",
    "flag": "🇼🇸"
  },
  {
    "name": "San Marino",
    "iso2": "SM",
    "iso3": "SMR",
    "phone": "+378",
    "flag": "🇸🇲"
  },
  {
    "name": "Saudi Arabia",
    "iso2": "SA",
    "iso3": "SAU",
    "phone": "+966",
    "flag": "🇸🇦"
  },
  {
    "name": "Senegal",
    "iso2": "SN",
    "iso3": "SEN",
    "phone": "+221",
    "flag": "🇸🇳"
  },
  {
    "name": "Serbia",
    "iso2": "RS",
    "iso3": "SRB",
    "phone": "+381",
    "flag": "🇷🇸"
  },
  {
    "name": "Seychelles",
    "iso2": "SC",
    "iso3": "SYC",
    "phone": "+248",
    "flag": "🇸🇨"
  },
  {
    "name": "Sierra Leone",
    "iso2": "SL",
    "iso3": "SLE",
    "phone": "+232",
    "flag": "🇸🇱"
  },
  {
    "name": "Singapore",
    "iso2": "SG",
    "iso3": "SGP",
    "phone": "+65",
    "flag": "🇸🇬"
  },
  {
    "name": "Sint Maarten",
    "iso2": "SX",
    "iso3": "SXM",
    "phone": "+1721",
    "flag": "🇸🇽"
  },
  {
    "name": "Slovakia",
    "iso2": "SK",
    "iso3": "SVK",
    "phone": "+421",
    "flag": "🇸🇰"
  },
  {
    "name": "Slovenia",
    "iso2": "SI",
    "iso3": "SVN",
    "phone": "+386",
    "flag": "🇸🇮"
  },
  {
    "name": "Solomon Islands",
    "iso2": "SB",
    "iso3": "SLB",
    "phone": "+677",
    "flag": "🇸🇧"
  },
  {
    "name": "Somalia",
    "iso2": "SO",
    "iso3": "SOM",
    "phone": "+252",
    "flag": "🇸🇴"
  },
  {
    "name": "South Africa",
    "iso2": "ZA",
    "iso3": "ZAF",
    "phone": "+27",
    "flag": "🇿🇦"
  },
  {
    "name": "South Georgia",
    "iso2": "GS",
    "iso3": "SGS",
    "phone": "+500",
    "flag": "🇬🇸"
  },
  {
    "name": "South Korea",
    "iso2": "KR",
    "iso3": "KOR",
    "phone": "+82",
    "flag": "🇰🇷"
  },
  {
    "name": "South Sudan",
    "iso2": "SS",
    "iso3": "SSD",
    "phone": "+211",
    "flag": "🇸🇸"
  },
  {
    "name": "Spain",
    "iso2": "ES",
    "iso3": "ESP",
    "phone": "+34",
    "flag": "🇪🇸"
  },
  {
    "name": "Sri Lanka",
    "iso2": "LK",
    "iso3": "LKA",
    "phone": "+94",
    "flag": "🇱🇰"
  },
  {
    "name": "Sudan",
    "iso2": "SD",
    "iso3": "SDN",
    "phone": "+249",
    "flag": "🇸🇩"
  },
  {
    "name": "Suriname",
    "iso2": "SR",
    "iso3": "SUR",
    "phone": "+597",
    "flag": "🇸🇷"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "iso2": "SJ",
    "iso3": "SJM",
    "phone": "+4779",
    "flag": "🇸🇯"
  },
  {
    "name": "Sweden",
    "iso2": "SE",
    "iso3": "SWE",
    "phone": "+46",
    "flag": "🇸🇪"
  },
  {
    "name": "Switzerland",
    "iso2": "CH",
    "iso3": "CHE",
    "phone": "+41",
    "flag": "🇨🇭"
  },
  {
    "name": "Syria",
    "iso2": "SY",
    "iso3": "SYR",
    "phone": "+963",
    "flag": "🇸🇾"
  },
  {
    "name": "São Tomé and Príncipe",
    "iso2": "ST",
    "iso3": "STP",
    "phone": "+239",
    "flag": "🇸🇹"
  },
  {
    "name": "Taiwan",
    "iso2": "TW",
    "iso3": "TWN",
    "phone": "+886",
    "flag": "🇹🇼"
  },
  {
    "name": "Tajikistan",
    "iso2": "TJ",
    "iso3": "TJK",
    "phone": "+992",
    "flag": "🇹🇯"
  },
  {
    "name": "Tanzania",
    "iso2": "TZ",
    "iso3": "TZA",
    "phone": "+255",
    "flag": "🇹🇿"
  },
  {
    "name": "Thailand",
    "iso2": "TH",
    "iso3": "THA",
    "phone": "+66",
    "flag": "🇹🇭"
  },
  {
    "name": "Timor-Leste",
    "iso2": "TL",
    "iso3": "TLS",
    "phone": "+670",
    "flag": "🇹🇱"
  },
  {
    "name": "Togo",
    "iso2": "TG",
    "iso3": "TGO",
    "phone": "+228",
    "flag": "🇹🇬"
  },
  {
    "name": "Tokelau",
    "iso2": "TK",
    "iso3": "TKL",
    "phone": "+690",
    "flag": "🇹🇰"
  },
  {
    "name": "Tonga",
    "iso2": "TO",
    "iso3": "TON",
    "phone": "+676",
    "flag": "🇹🇴"
  },
  {
    "name": "Trinidad and Tobago",
    "iso2": "TT",
    "iso3": "TTO",
    "phone": "+1868",
    "flag": "🇹🇹"
  },
  {
    "name": "Tunisia",
    "iso2": "TN",
    "iso3": "TUN",
    "phone": "+216",
    "flag": "🇹🇳"
  },
  {
    "name": "Turkey",
    "iso2": "TR",
    "iso3": "TUR",
    "phone": "+90",
    "flag": "🇹🇷"
  },
  {
    "name": "Turkmenistan",
    "iso2": "TM",
    "iso3": "TKM",
    "phone": "+993",
    "flag": "🇹🇲"
  },
  {
    "name": "Turks and Caicos Islands",
    "iso2": "TC",
    "iso3": "TCA",
    "phone": "+1649",
    "flag": "🇹🇨"
  },
  {
    "name": "Tuvalu",
    "iso2": "TV",
    "iso3": "TUV",
    "phone": "+688",
    "flag": "🇹🇻"
  },
  {
    "name": "Uganda",
    "iso2": "UG",
    "iso3": "UGA",
    "phone": "+256",
    "flag": "🇺🇬"
  },
  {
    "name": "Ukraine",
    "iso2": "UA",
    "iso3": "UKR",
    "phone": "+380",
    "flag": "🇺🇦"
  },
  {
    "name": "United Arab Emirates",
    "iso2": "AE",
    "iso3": "ARE",
    "phone": "+971",
    "flag": "🇦🇪"
  },
  {
    "name": "United Kingdom",
    "iso2": "GB",
    "iso3": "GBR",
    "phone": "+44",
    "flag": "🇬🇧"
  },
  {
    "name": "United States",
    "iso2": "US",
    "iso3": "USA",
    "phone": "+1201",
    "flag": "🇺🇸"
  },
  {
    "name": "United States Minor Outlying Islands",
    "iso2": "UM",
    "iso3": "UMI",
    "phone": "+268",
    "flag": "🇺🇲"
  },
  {
    "name": "United States Virgin Islands",
    "iso2": "VI",
    "iso3": "VIR",
    "phone": "+1340",
    "flag": "🇻🇮"
  },
  {
    "name": "Uruguay",
    "iso2": "UY",
    "iso3": "URY",
    "phone": "+598",
    "flag": "🇺🇾"
  },
  {
    "name": "Uzbekistan",
    "iso2": "UZ",
    "iso3": "UZB",
    "phone": "+998",
    "flag": "🇺🇿"
  },
  {
    "name": "Vanuatu",
    "iso2": "VU",
    "iso3": "VUT",
    "phone": "+678",
    "flag": "🇻🇺"
  },
  {
    "name": "Vatican City",
    "iso2": "VA",
    "iso3": "VAT",
    "phone": "+3906698",
    "flag": "🇻🇦"
  },
  {
    "name": "Venezuela",
    "iso2": "VE",
    "iso3": "VEN",
    "phone": "+58",
    "flag": "🇻🇪"
  },
  {
    "name": "Vietnam",
    "iso2": "VN",
    "iso3": "VNM",
    "phone": "+84",
    "flag": "🇻🇳"
  },
  {
    "name": "Wallis and Futuna",
    "iso2": "WF",
    "iso3": "WLF",
    "phone": "+681",
    "flag": "🇼🇫"
  },
  {
    "name": "Western Sahara",
    "iso2": "EH",
    "iso3": "ESH",
    "phone": "+2125288",
    "flag": "🇪🇭"
  },
  {
    "name": "Yemen",
    "iso2": "YE",
    "iso3": "YEM",
    "phone": "+967",
    "flag": "🇾🇪"
  },
  {
    "name": "Zambia",
    "iso2": "ZM",
    "iso3": "ZMB",
    "phone": "+260",
    "flag": "🇿🇲"
  },
  {
    "name": "Zimbabwe",
    "iso2": "ZW",
    "iso3": "ZWE",
    "phone": "+263",
    "flag": "🇿🇼"
  },
  {
    "name": "Åland Islands",
    "iso2": "AX",
    "iso3": "ALA",
    "phone": "+35818",
    "flag": "🇦🇽"
  }
];
